export const LOG_ANALYTICS_EVENT = '[Analytics]/LOG_ANALYTICS_EVENT';
